import React from "react";

import { getCurrentLang } from "./Local";
import { formatMoney } from "./Toolbox";

import type { ICartItem } from "@/interfaces/ICart";
import type { IProject } from "@/interfaces/IProject";

type TranslateFunction = (key: string) => string;

export const displayItemTotal = (item: ICartItem): React.JSX.Element => {
  if (item.list === item.price) {
    return <div>{formatMoney(item.quantity * (item.price / 100))}</div>;
  }

  return (
    <React.Fragment>
      <div className="text-decoration-line-through">
        {formatMoney(item.quantity * (item.list / 100))}
      </div>
      <div className="text-danger">
        {formatMoney(item.quantity * (item.price / 100))}
      </div>
    </React.Fragment>
  );
};

const displayConstructionTime = (
  num_weeks: number,
  t: TranslateFunction,
): string => {
  const label = num_weeks < 2 ? t("day") : t("days");
  return `${num_weeks} ${label}`;
};
const displayCompletionDate = (completionDate: string) => {
  const lang = getCurrentLang();
  const dateValues = completionDate.split("-");
  const date = new Date(`${dateValues[0]}/${dateValues[1]}/${dateValues[2]}`);
  const locale = lang === "fr" ? "fr-CA" : "en-CA";
  return date.toLocaleDateString(locale, { month: "long", year: "numeric" });
};

export const displayProjectInfo = (
  project: IProject,
  t: TranslateFunction,
): React.JSX.Element => {
  const lang = getCurrentLang();
  return (
    <ul>
      <li>
        {t("footprint")}: {project.footprint} {t("sq_ft")}
        {project.footprint_note ? (
          <span className="ps-1">{project.footprint_note[lang]}</span>
        ) : null}
      </li>
      {project.under_development ? <li>{t("Under development")}</li> : null}
      {project.completion_date ? (
        <li>
          {t("Completion date")}:{" "}
          {displayCompletionDate(project.completion_date)}
        </li>
      ) : null}
      {project.installation_time ? (
        <li>
          {t("Installation time")}:{" "}
          {displayConstructionTime(project.installation_time, t)}
        </li>
      ) : null}
      <li>
        {t("Built from PakVert™ panels")}, {project.bottles.toLocaleString()}{" "}
        {t("recycled plastic bottles")}
      </li>
    </ul>
  );
};
